import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "recherche-home",
    component: Home,
  },
  {
    path: "/search/",
    name: "recherche-search",
    component: () =>
      import(/* webpackChunkName: "recherche" */ "../views/Recherche.vue"),

    children: [
      {
        path: "list",
        name: "recherche-list",
        component: () =>
          import(
            /* webpackChunkName: "list" */ "../components/presentation_liste.vue"
          ),
      },
      {
        path: "graph",
        name: "recherche-graph",
        component: () =>
          import(
            /* webpackChunkName: "graph" */ "../components/presentation_graph.vue"
          ),
      },
      {
        path: "results",
        name: "recherche-results",
        component: () =>
          import(
            /* webpackChunkName: "results" */ "../components/presentation_resultatRecherche.vue"
          ),
      },
      {
        path: "tree",
        name: "recherche-tree",
        component: () =>
          import(
            /* webpackChunkName: "tree" */ "../components/presentation_tree.vue"
          ),
      },
    ],
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contact.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
